import { AxiosResponse } from 'axios';
import { getData, postData, delData } from '../../../utils/fetch-api-util';
import { API_URLS } from '../../../constants/urls/api-urls';

export interface CreateImagePayload {
  keyImage: string;
  urlImage: string;
}
export interface UpdateImagePayload {
  id: string;
  keyImage: string;
  urlImage?: string;
}
export const getImagesRepository = async (): Promise<any[]> => {
  const response = await getData<{}, []>(API_URLS.IMAGE_LIST);
  return response.data;
};

export const saveImageRepository = (data: CreateImagePayload): Promise<AxiosResponse<any>> => {
  return postData(API_URLS.IMAGE_SAVE, data);
};

export const updateImageRepository = (payload: UpdateImagePayload): Promise<AxiosResponse<any>> => {
  return postData(API_URLS.IMAGE_UPDATE, payload);
};

export const deleteImageRepository = (imageId: string): Promise<AxiosResponse<any>> => {
  return delData(API_URLS.IMAGE_DELETE + imageId);
};
